module.exports = __webpack_public_path__ + "build/img/01.7fbef12f.jpg";